import React from 'react';
import PropTypes from 'prop-types';

import { v4 as uuidv4 } from 'uuid';
import { isEqual } from 'lodash';

class ScrollInViewHOC extends React.Component {
    constructor(props) {
        super(props);

        const {
            children,
        } = props;

        this.id = children?.props?.id || uuidv4();
    }

    componentDidMount() {
        const {
            scrollOnMount,
        } = this.props;

        if (scrollOnMount) {
            this.scroll();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            changeDetection,
        } = this.props;

        if (!isEqual(prevProps.changeDetection, changeDetection)) {
            this.scroll();
        }
    }

    scroll = () => {
        const element = document.getElementById(this.id);
        if (element) {
            element.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
            });
        }
    }

    render() {
        const {
            children,
        } = this.props;

        if (children?.props?.id) {
            return children;
        }

        // add id if not there
        return React.cloneElement(children, {
            id: this.id,
        });
    }
}

ScrollInViewHOC.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    changeDetection: PropTypes.any.isRequired,
    scrollOnMount: PropTypes.bool,
};

ScrollInViewHOC.defaultProps = {
    scrollOnMount: true,
};

export default ScrollInViewHOC;
